import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import GMARouter, { history } from './GMARouter';
import { HomePage } from './pages/HomePage';
import './App.css';
import './toolkit/styles/toolkit.css';
import { useEffect, useState } from 'react';
import { SessionProvider } from './contexts/SessionContext';
import { APIContext, APIProvider } from './contexts/APIContext';
import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { useMsal } from '@azure/msal-react';
import { GeneralErrorPage } from './pages/GeneralErrorPage';
import { LogoutPage } from './pages/LogoutPage';
import { Error404Page } from './pages/Error404Page';
import appInsights from './appInsights';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorBoundaryFallback } from './components/ErrorBoundaryFallback';
import SessionWarningModal from './components/SessionWarning';
import Logoutpopup from './components/logoutpopup';
import { ChatbotProvider } from './contexts/ChatbotContext';
import { Toaster } from './components/ui/toast/Toaster';
// import { msalApp } from './authConfig';
import { msalInstance } from '.';
import { getlogoutFlag, getValidToken } from './utils';

function App() {
  // Flag to denote whether the chat should be reset (when the reset btn in the MODAL is clicked)
  const [resetApp, setResetApp] = useState<boolean>(false);
  const [sessionTimeout] = useState<number>(56 * 60 * 1000); // 56 minutes
  const [logoutTimeout] = useState<number>(4 * 60 * 1000); // 4 minutes
  const [sessionWarning, setSessionWarning] = useState<boolean>(false);

  // Define user from SSO
  const { accounts, instance } = useMsal();
  const isAuthenticated = accounts.length > 0;
  const username = isAuthenticated ? accounts[0].username : 'Guest';
  const {
    websocketConnectionRef: { current: websocket },
    stopSignalRConnection,
  } = useContext(APIContext);

  // Use effect to track sign-ins
  useEffect(() => {
    if (isAuthenticated) {
      appInsights.trackEvent({
        name: 'UserLogin',
        properties: { username },
      });
    }
  }, [isAuthenticated, username]);

  // Use effect to handle sessionTimeOuts

  let sessionTimer: number;
  let logoutTimer: number;
  useEffect(() => {
    const startLogoutTimer = () => {
      logoutTimer = window.setTimeout(async () => {
        const token = await getValidToken();
        getlogoutFlag(websocket, accounts, token);
        await stopSignalRConnection();
        msalInstance.logoutRedirect();
      }, logoutTimeout);
    };
    if (sessionWarning) {
      startLogoutTimer();
    } else clearTimeout(logoutTimer);
  }, [sessionWarning]);

  const startSessionTimer = () => {
    sessionTimer = window.setTimeout(() => {
      setSessionWarning(true);
    }, sessionTimeout);
  };

  const resetSessionTimer = () => {
    if (!sessionWarning) {
      clearTimeout(sessionTimer);
      startSessionTimer();
    }
  };

  resetSessionTimer();
  const eventListeners = ['scroll', 'mousemove', 'keydown', 'click'].map((event) => {
    window.addEventListener(event, resetSessionTimer);
    return () => window.removeEventListener(event, resetSessionTimer);
  });
  const handleContinue = () => {
    clearTimeout(logoutTimer);
  };

  return (
    /* MsalAuthenticationTemplate automatically handles authentication challenges */
    <MsalAuthenticationTemplate
      interactionType={window.self === window.top ? InteractionType.Redirect : InteractionType.Popup}
    >
      <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
        <div className="h-screen-custom  bg-gamma-bg-primary font-graphik text-center">
          <SessionProvider>
            <ChatbotProvider resetApp={resetApp} setResetApp={setResetApp}>
              <GMARouter history={history}>
                <APIProvider>
                  {/* Toaster component used at parent level so it can be called anywhere using the useToast hook */}
                  <Toaster />
                  <Routes>
                    <Route path="/" element={<HomePage resetApp={resetApp} setResetApp={setResetApp} />} />
                    <Route path="/error" element={<GeneralErrorPage />} />
                    <Route path="/logout" element={<LogoutPage />} />
                    {/* <Route path="/signout" element={<Logoutpopup />} /> */}
                    <Route path="*" element={<Error404Page />} />
                  </Routes>
                </APIProvider>
              </GMARouter>
            </ChatbotProvider>
          </SessionProvider>
          {location.pathname !== '/signout' && sessionWarning && (
            <SessionWarningModal
              sessionWarning={sessionWarning}
              setSessionWarning={setSessionWarning}
              handleContinue={handleContinue}
            />
          )}
        </div>
      </ErrorBoundary>
    </MsalAuthenticationTemplate>
  );
}

export default App;
